import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function getBusinesses(params = {}) {
  const res = await api.get("/businesses", { params });
  return res.data;
}

export async function getStats() {
  const res = await api.get("/stats");
  return res.data;
}

export async function subscribeNewsletter({ email, name }) {
  const res = await api.post("/newsletter/subscribe", { email, name });
  return res.data;
}

export async function submitContact(payload) {
  const res = await api.post("/contact", payload);
  return res.data;
}
